import { render, staticRenderFns } from "./PappersAuditors.vue?vue&type=template&id=66cfa08e&scoped=true"
import script from "./PappersAuditors.vue?vue&type=script&lang=js"
export * from "./PappersAuditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cfa08e",
  null
  
)

export default component.exports